import { render, staticRenderFns } from "./line_items.vue?vue&type=template&id=1c8e8664&"
import script from "./line_items.vue?vue&type=script&lang=js&"
export * from "./line_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports